'use client';

import type { EventBusListener } from '@hc-frontend/core-events';
import { useEventBus } from '@hc-frontend/core-ui';
import { trackRedirection } from '@hc-frontend/third-party-snowplow';
import { useCallback, useEffect } from 'react';

import type {
  RedirectionTrackingEvent,
  RedirectionTrackingEventTarget,
} from './redirection-tracking-subscription.types';

function trackRedirectionWithContext(event: RedirectionTrackingEvent) {
  const {
    description,
    redirectType,
    sourceCategory,
    targetApplication,
    targetUrl,
    sourceFunnel,
  } = event;
  trackRedirection(
    {
      redirectType,
      sourceCategory,
      sourceFunnel,
      targetUrl,
      targetApplication,
      description,
    },
    [],
  );
}

export function RedirectionTrackingSubscription() {
  const eventBus = useEventBus();

  const handleRedirectionTracking = useCallback<
    EventBusListener<RedirectionTrackingEvent, RedirectionTrackingEventTarget>
  >((event) => trackRedirectionWithContext(event), []);

  useEffect(() => {
    eventBus.subscribe('core.ui.page.redirection', handleRedirectionTracking);

    return () => {
      eventBus.unsubscribe(
        'core.ui.page.redirection',
        handleRedirectionTracking,
      );
    };
  }, [handleRedirectionTracking, eventBus]);

  return null;
}
